import React, { useMemo } from "react";
import { Box } from "@mui/material";
import { useParams } from "react-router-dom";
import { StepUpSpinner } from "../../../Components/Loader";
import { useShowParentQuery } from "../../../Api/attoDeskApi";
import ParentForm, { IParentFormValues } from "../Component/ParentForm";

const EditParent = () => {
  const { id = "" } = useParams();
  const { data, isLoading } = useShowParentQuery(id, { skip: !id });

  const parent = data?.data as any;

  const initialValues: Partial<IParentFormValues> | undefined = useMemo(() => {
    if (!parent) return undefined;
    return {
      first_name: parent.first_name || "",
      middle_name: parent.middle_name || "",
      last_name: parent.last_name || "",
      contact_number: parent.phone || "",
      email: parent.email || "",
      address: parent.address || "",
      country_code: (parent.country_code as "CA" | "US" | undefined) || "",
      is_email_notification: !!parent.is_email_notification,
      is_sms_notification: !!parent.is_sms_notification,
      is_payment_reminder: !!parent.is_payment_reminder,
    };
  }, [parent]);

  if (isLoading || !parent) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="40vh">
        <StepUpSpinner size="medium" />
      </Box>
    );
  }

  return (
    <Box sx={{ p: { xs: 1, md: 2 } }}>
      <ParentForm
        parentId={id}
        title="Edit Parent"
        initialValues={initialValues}
        account={{
          has_account: !!parent.has_account,
          username: parent.username,
          account_email: parent.account_email,
          account_status: parent.account_status,
          last_login: parent.last_login,
        }}
      />
    </Box>
  );
};

export default EditParent;
